<div class="number">404</div>
<div class="text">
  <span>Ooops...</span>
  <br>
  page not found
  <br>
  <a routerLink="/">Go to homepage</a>
</div>

